import { Link } from "react-router-dom";

export function GoldButton({ to, href, children, className = "", onClick, type, testid, ...rest }) {
  const cls = `btn-gold inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-xs sm:text-sm uppercase tracking-wider ${className}`;
  if (to) return <Link to={to} className={cls} data-testid={testid} {...rest}>{children}</Link>;
  if (href) return <a href={href} className={cls} data-testid={testid} {...rest}>{children}</a>;
  return <button type={type || "button"} onClick={onClick} className={cls} data-testid={testid} {...rest}>{children}</button>;
}

export function GhostButton({ to, children, className = "", onClick, testid, ...rest }) {
  const cls = `btn-ghost inline-flex items-center justify-center gap-2 rounded-full px-7 py-3.5 text-xs sm:text-sm uppercase tracking-wider ${className}`;
  if (to) return <Link to={to} className={cls} data-testid={testid} {...rest}>{children}</Link>;
  return <button onClick={onClick} className={cls} data-testid={testid} {...rest}>{children}</button>;
}
